'use strict';

const SESSION_ID = 'trackingPageFlow';

class FlowCache {
    getQueues() {
        return JSON.parse(Odigeo.Session.get(SESSION_ID)) || {};
    }

    getQueue(flow) {
        return this.getQueues()[flow] || [];
    }

    storeQueue(flow, queue) {
        const queues = this.getQueues();
        queues[flow] = queue;
        Odigeo.Session.set(SESSION_ID, JSON.stringify(queues));
    }

    enqueue({flow, label}) {
        const queue = this.getQueue(flow);

        if (this.getLastQueueElement(queue) !== label) {
            queue.push(label);
            this.storeQueue(flow, queue);
        }

        return queue;
    }

    getLastQueueElement(queue = []) {
        return queue.slice(-1)[0];
    }

    clear() {
        Odigeo.Session.set(SESSION_ID, '{}');
    }
}

module.exports = new FlowCache();
